import type { UiStrings } from "../types";

export const fr: UiStrings = {
  nav: {
    category: "Catégorie",
    forYourWork: "Pour votre Travail",
    searchPlaceholder: "Rechercher parmi plus de 300 outils...",
    heroPlaceholder: "Qu'avez-vous en tête ?",
  },
  trustBadges: {
    noLogin: "Aucune connexion pour utiliser les outils",
    freeUsesDaily: "10 utilisations d'essai par jour",
    filesNeverStored: "Vos fichiers ne sont jamais stockés",
    worksAnyDevice: "Fonctionne sur tous les appareils",
    worksWhenAiBlocked: "Fonctionne même si l'IA est bloquée par votre entreprise",
    availableInLanguages: "Disponible en plusieurs langues",
  },
  common: {
    backToHome: "Retour à l'Accueil",
    home: "Accueil",
    signIn: "Se Connecter",
    account: "Compte",
    contact: "Contact",
    blog: "Blog",
    shareThisTool: "Partager cet outil",
    download: "Télécharger",
    copy: "Copier",
    copied: "Copié",
  },
  footer: {
    tagline: "Votre plateforme de productivité tout-en-un. Plus de 300 outils professionnels, applications premium et produits de workflow pour le quotidien.",
    company: "Entreprise",
    about: "À propos",
    blog: "Blog",
    contact: "Contact",
    pricing: "Tarifs",
    privacyPolicy: "Politique de Confidentialité",
    termsOfService: "Conditions d'Utilisation",
    allTools: "Tous les Outils",
    allRightsReserved: "Tous droits réservés.",
  },
  contact: {
    title: "Contactez-nous",
    subtitle: "Des questions, des retours, ou quelque chose ne fonctionne pas correctement ? Nous sommes là pour vous aider.",
    email: "E-mail",
    responseTime: "Délai de Réponse",
    responseTimeValue: "Nous répondons généralement sous 1 à 2 jours ouvrés.",
    sendEmail: "Envoyez-nous un e-mail",
    billingNote: "Pour toute question de facturation, veuillez inclure l'adresse e-mail associée à votre compte.",
    whoWeAreTitle: "Qui gère FreeDailyPro",
    whoWeAreBody: "FreeDailyPro est géré par DreamUSA LLC, une petite entreprise de logiciels gérée de manière indépendante. Il n'y a pas de grande équipe de support derrière cela -- la personne qui lit et répond à votre e-mail est aussi celle qui crée et maintient les outils, ce qui explique pourquoi une réponse prend parfois un jour ou deux plutôt que d'être instantanée.",
    whatWeSupportTitle: "Ce avec quoi nous pouvons vous aider",
    whatWeSupportBody: "Signalements de bugs pour l'un des 300+ outils, demandes de fonctionnalités, questions de facturation et d'abonnement (y compris annulations et remboursements), problèmes de compte et de connexion, et retours généraux sur ce qui fonctionne bien ou non. Si un outil a produit un résultat incorrect, indiquer le type de fichier et ce qui s'est mal passé aide à le corriger plus rapidement.",
  },
  home: {
    heroTitleLine1: "Chaque tâche professionnelle.",
    heroTitleLine2: "Une plateforme dans le navigateur",
    heroSubtitle: "Utilisez un outil. Exécutez un workflow. Créez avec l'API et MCP. Ou laissez-nous le créer pour vous.",
    localSignalUsedTitle: "Utilisés sur cet appareil",
    localSignalTryTitle: "Essayez l'un de ceux-ci",
    localSignalBadge: "Local \u00b7 Aucun réseau",
    localSignalUsedDesc: "outils utilisés sur cet appareil \u2014 rien n'a quitté votre navigateur",
    localSignalTryDesc: "outils utilisés jusqu'à présent sur cet appareil \u2014 tout s'exécute directement dans votre navigateur",
    corporateSafeTitle: "Sûr pour l'entreprise",
    corporateSafeSubtitle: "Quelle que soit la politique IA de votre entreprise, FreeDailyPro fonctionne de la même façon",
    corporateSafeBlockedTitle: "Totalement bloqué",
    corporateSafeBlockedDesc: "Aucun outil d'IA n'est autorisé sur le réseau. Tous les outils FreeDailyPro fonctionnent quand même \u2014 rien n'est jamais envoyé à un serveur.",
    corporateSafeGovernedTitle: "Accès contrôlé",
    corporateSafeGovernedDesc: "L'IA n'est autorisée que via des outils approuvés et vérifiés. Rien ici n'a besoin d'approbation \u2014 il n'y a aucun appel à un serveur externe à vérifier.",
    corporateSafeOpenTitle: "Aucune restriction",
    corporateSafeOpenDesc: "Utilisez ce qui fait le travail. FreeDailyPro est simplement plus rapide, puisqu'il n'y a rien à envoyer ni à attendre.",
    corporateSafeCta: "Voir le détail complet pour les entreprises \u2192",
    exploreToolkitTitle: "Découvrez la boîte à outils",
    exploreToolkitSubtitle: "Plus de 300 outils répartis en {catCount} catégories \u2014 choisissez-en une, ou recherchez simplement.",
    forYourWorkTitle: "Conçu pour votre façon de travailler",
    forYourWorkSubtitle: "Les mêmes outils professionnels, organisés selon votre métier",
    exploreTools: "Découvrir les outils",
    seeAllRoles: "Voir les {count} métiers \u2192",
    blogTitle: "Sur le Blog",
    viewAllPosts: "Voir Tous les Articles",
    faqTitle: "Une question ? Consultez notre FAQ",
    faqMoreLink: "Vous cherchez d'autres réponses ? Parcourez la FAQ complète \u2192",
    toolkitProseTitle: "Une boîte à outils professionnelle pensée pour le travail quotidien, pas seulement pour des tâches ponctuelles",
    closingCtaTitle: "N'oubliez pas d'ajouter le raccourci",
    closingCtaDesc: "Ajoutez-le une fois et il sera toujours à portée de clic \u2014 installez le raccourci sur le bureau ou ajoutez-le à l'écran d'accueil de votre téléphone, et FreeDailyPro s'ouvrira comme une application native, sans avoir à chercher un onglet.",
    categoriesLabel: "{count} CATÉGORIES \u2192",
    viewAllCategoriesLabel: "VOIR LES {count} CATÉGORIES \u2192",
    yourFavorites: "Vos Favoris",
    recentlyUsed: "Récemment Utilisés",
    toolkitProsePara1: "FreeDailyPro rassemble plus de 300 outils du quotidien \u2014 édition de PDF, conversion d'images, découpage vidéo, nettoyage audio, formatage de texte et des dizaines de calculatrices \u2014 en un seul endroit, pour ne plus avoir à changer de site pour chaque tâche. La plupart des outils ne nécessitent aucune inscription, et les outils basés sur les fichiers incluent 10 utilisations gratuites par jour.",
    toolkitProsePara2: "Chaque outil s'exécute entièrement dans votre navigateur. Lorsque vous compressez un PDF ou supprimez l'arrière-plan d'une photo, ce fichier ne quitte jamais votre appareil \u2014 il n'est ni téléversé, ni traité sur un serveur, ni stocké nulle part, même temporairement. Ce n'est pas une limitation, c'est toute la conception : des résultats plus rapides, et rien à craindre si le fichier est sensible.",
    toolkitProsePara3: "Cette approche locale signifie aussi que FreeDailyPro fonctionne de la même façon, que vous soyez sur un ordinateur personnel, une machine professionnelle verrouillée, ou un réseau avec des politiques d'utilisation de l'IA strictes \u2014 il n'y a aucun appel à un serveur externe à évaluer pour l'informatique, car il n'y en a tout simplement pas.",
    toolkitProsePara4: "Que vous ayez besoin de fusionner des PDF pour un rapport, redimensionner une image pour une annonce, découper un extrait vidéo pour les réseaux sociaux, ou faire un calcul rapide de prêt immobilier ou d'impôts, FreeDailyPro est conçu pour être l'outil que vous utilisez au quotidien \u2014 pas seulement celui dont vous vous souvenez quand vous en avez besoin.",
    heroLaneToolsTitle: "Outils professionnels pour tâches individuelles",
    heroLaneToolsDesc: "PDF, image, vidéo et plus -- une action, faite dans votre navigateur.",
    heroLaneToolsCta: "Parcourir les outils",
    heroLanePremiumTitle: "Applications premium pour les gros travaux",
    heroLanePremiumDesc: "Apps multi-étapes : documents, formulaires, planificateurs, impression et événements.",
    heroLanePremiumCta: "Voir les applications",
    heroLaneWorkflowTitle: "Produits de workflow",
    heroLaneWorkflowDesc: "Book Writing Toolbox, Event Suite et plus -- plusieurs étapes, un résultat.",
    heroLaneWorkflowCta: "Voir les produits de workflow",
    heroLaneApiTitle: "API et MCP",
    heroLaneApiDesc: "Appelez les mêmes outils depuis votre propre code ou agent IA.",
    heroLaneApiCta: "Ouvrir la section développeurs",
    heroLaneCustomTitle: "Logiciel sur mesure",
    heroLaneCustomDesc: "Dites-nous ce qu'il vous faut. Nous le développons pour un paiement unique, puis vous réglez un petit abonnement mensuel d'utilisation.",
    heroLaneCustomCta: "Demander un développement",
  },
  install: {
    desktopTitle: "Raccourci Bureau",
    desktopSubtitle: "Un clic, s'ouvre instantanément",
    mobileTitle: "Application Mobile",
    mobileSubtitle: "Ajoutez à votre écran d'accueil",
    addToHomeScreenTitle: "Ajoutez FreeDailyPro à votre écran d'accueil",
    iosInstructions: "Appuyez sur l'icône Partager dans Safari, puis choisissez \"Sur l'écran d'accueil.\"",
    genericInstructions: "Ouvrez le menu de votre navigateur et cherchez \"Ajouter à l'écran d'accueil\" ou \"Installer l'application.\"",
    desktopUnavailableTitle: "L'installation en un clic n'est pas disponible dans ce navigateur",
    desktopUnavailableDesc: "Vous pouvez toujours ajouter cette page à vos favoris, ou faire glisser l'icône de la barre d'adresse vers votre bureau.",
    desktopSuccess: "Raccourci créé ! Cherchez l'icône FreeDailyPro.",
    mobileSuccess: "Ajouté ! Cherchez l'icône FreeDailyPro sur votre écran d'accueil.",
  },
  toolPage: {
    proBadge: "Pro",
    usesRemainingToday: "{count} utilisations d'essai restantes aujourd'hui",
    whatThisToolDoes: "Ce que fait cet outil",
    proTips: "Astuces Pro",
    continueWith: "Continuer avec",
    moreFromCategory: "Plus dans cette catégorie",
  },
  usageStrip: {
    freeUsesPerDay: "Essai : {limit} utilisations/jour",
    remainingToday: "{count} restantes aujourd'hui",
    dayPassLabel: "Usage illimité sans publicité, pass journalier à 1 $",
    monthlyLabel: "Usage illimité sans publicité, pass mensuel à 4,99 $",
    quickBuy: "Achat rapide",
  },
  platformsBanner: {
    title: "Où cette API se trouve réellement",
    subtitle: "Pas une page qui dit \"bientôt disponible\" -- ce sont de vraies listes fonctionnelles auxquelles vous pouvez vous abonner ou vous connecter dès aujourd'hui.",
    postmanDetail: "Requêtes prêtes à l'emploi, entièrement documentées",
    rapidApiDetail: "Abonnez-vous avec une facturation à l'usage via la marketplace de Rapid",
    mcpRegistryDetail: "Officiellement répertorié sous com.freedailypro/tools, {mcp} outils, un seul point d'accès",
  },
  pricingBanner: {
    title: "Tarification transparente",
    subtitle: "Aucun palier caché, aucune limite surprise -- exactement ce que coûte chaque formule et ce qu'elle offre.",
    toolPricingTitle: "Tarification des outils à l'usage",
    apiPricingTitle: "Tarification API et MCP à l'usage",
    freeLabel: "Essai",
    freeToolDetail: "10 utilisations/jour pour Professional Tools, 2 pour Premium Applications",
    dayPassDetail: "1 $/jour -- usage illimité sans publicité",
    monthlyDetail: "4,99 $/mois -- usage illimité sans publicité",
    monthlySavingsNote: "Moins cher que 5 pass journaliers par mois",
    freeApiDetail: "20 000 appels/mois",
    premiumDetail: "24 $/mois -- 200 000 appels",
    ultraDetail: "69 $/mois -- 750 000 appels",
    megaDetail: "129 $/mois -- 2 000 000 appels + priorité",
  },
  apiMcpBanner: {
    title: "Maintenant avec API et MCP",
    description: "Appelez nos plus de 200 outils directement depuis votre propre code, ou connectez un agent IA via MCP -- les mêmes outils, côté serveur, pour quand le navigateur seul ne suffit pas.",
    oneKey: "Une seule clé pour tout",
    restApiMcp: "API REST + MCP",
    anyLanguage: "N'importe quel langage, n'importe quel serveur",
    cta: "Découvrir l'API et MCP",
  },
  premiumApps: {
    title: "Applications Premium",
    subtitle: "De véritables applications multi-étapes, pas de simples outils à action unique -- installables indépendamment aussi.",
    seeAll: "Voir toutes les applications Premium",
  },
  googleDrive: {
    openFromGoogle: "Ouvrir depuis Google Drive",
    saveToGoogle: "Enregistrer dans Google Drive",
    signingIn: "Ouverture de la connexion Google...",
    fetching: "Récupération de votre fichier depuis Google Drive...",
    saving: "Enregistrement dans Google Drive...",
    saved: "Enregistré dans Google Drive",
    viewInDrive: "Voir dans Drive",
    popupBlocked: "Votre navigateur a bloqué la fenêtre de connexion Google. Autorisez les fenêtres pop-up pour ce site, puis réessayez.",
    cancelled: "La connexion Google a été fermée avant la fin. Rien n'a été ouvert ni enregistré.",
    denied: "L'accès à Google Drive n'a pas été autorisé, donc rien n'a été ouvert ni enregistré. Réessayez et autorisez l'accès aux fichiers que vous choisissez.",
    loadFailed: "Impossible de joindre Google. Vérifiez votre connexion ou votre bloqueur de contenu, puis réessayez.",
    network: "La connexion à Google Drive a été interrompue. Veuillez réessayer.",
    tooLarge: "Ce fichier est trop volumineux pour être ouvert dans le navigateur.",
    api: "Google Drive n'a pas pu terminer l'opération. Veuillez réessayer.",
    largeFile: "Ce fichier dépasse 50 Mo. Cela peut être plus long ou saturer la mémoire du navigateur.",
    privacyNote: "Votre fichier circule entre votre navigateur et Google. Il n'est pas envoyé à nos serveurs.",
  },
};
